module.exports = __webpack_public_path__ + "img/remove.f4f56db4.svg";